import axiosInstance from './AxiosInstance';
const quizUrl = "api/admin_quiz"
const userQuizUrl = "api/user_quiz"

export function getQuizListApi(page, page_size, filters = {}) {
    const params = new URLSearchParams({
        page,
        page_size,
        ...filters
    });
    return axiosInstance.get(`${quizUrl}?${params.toString()}`);
}

export function getQuizParticipationListApi(id, page, page_size, filters = {}) {
    const params = new URLSearchParams({
        page,
        page_size,
        ...filters
    });
    return axiosInstance.get(`api/admin_quiz_participation/${id}?${params.toString()}`);
}

export function getQuizApi(id) {
    return axiosInstance.get(`${quizUrl}/${id}`);
}

export function createQuizApi(data) {
    return axiosInstance.post(quizUrl, data);
}

export function updateQuizApi(data) {
    return axiosInstance.put(quizUrl, data);
}

export function getUserQuizListApi(page, page_size, filters = {}) {
    const params = new URLSearchParams({
        page,
        page_size,
        ...filters
    });
    return axiosInstance.get(`${userQuizUrl}?${params.toString()}`);
}

export function getUserQuizApi(id) {
    return axiosInstance.get(`${userQuizUrl}/${id}`);
}

export function createUserQuizParticipationApi(data) {
    return axiosInstance.post(userQuizUrl, data);
}

export function submitUserQuizAnswerApi(data) {
    return axiosInstance.put(userQuizUrl, data);
}

export function submitUserQuizFeedbackApi(data) {
    return axiosInstance.patch(userQuizUrl, data);
}

export function getParticipatorAnswerApi(participationID) {
    return axiosInstance.get(`api/participation_answer/${participationID}`);
}

export function getTopParticipantApi(quizId) {
    return axiosInstance.get(`api/top_participation/${quizId}`);
}